import CompanyCategoriesMainPage from './main';
import CompanyCategoryEdit from './edit';
import SingleCompanyCategory from './singleCategory';
const routes = [
  {
    path: '/*',
    Component: CompanyCategoriesMainPage,
    props: {},
  },
  {
    path: '/:id/edit',
    Component: CompanyCategoryEdit,
    props: {},
  },
  {
    path: '/:id',
    Component: SingleCompanyCategory,
    props: {},
  },
  {
    path: '/new',
    Component: CompanyCategoryEdit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
